import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper/modules';
import onReady from '@/scripts/modules/on-ready';

onReady(() => {
  const promoCarousel = document.querySelector('.promo-header__carousel');

  if (promoCarousel) {
    const slides = promoCarousel.querySelectorAll('.swiper-slide');

    if (slides.length > 1) {
      Swiper.use([Autoplay, Navigation, Pagination, Scrollbar]);
      new Swiper(promoCarousel, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: promoCarousel.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    }
  }
});
